import { render, staticRenderFns } from "./videoUpload.vue?vue&type=template&id=31c49cd6&"
import script from "./videoUpload.vue?vue&type=script&lang=js&"
export * from "./videoUpload.vue?vue&type=script&lang=js&"
import style0 from "./videoUpload.vue?vue&type=style&index=0&id=31c49cd6&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports